module.exports = {
          srcSet: __webpack_public_path__ + "ddfd9f5e7ee25c4ddbd3e4172dab4fb2-412.png"+" 412w",
          images:[ {path: __webpack_public_path__ + "ddfd9f5e7ee25c4ddbd3e4172dab4fb2-412.png",width: 412,height: 434}],
          src: __webpack_public_path__ + "ddfd9f5e7ee25c4ddbd3e4172dab4fb2-412.png",
          toString:function(){return __webpack_public_path__ + "ddfd9f5e7ee25c4ddbd3e4172dab4fb2-412.png"},
          
          width: 412,
          height: 434
        }